export default "__VITE_ASSET__73caab16__"